import Vue from 'vue';
import Vuex from 'vuex';
import { IDataSetStoreState } from './store.dataSet';
import { ISettingsReportStoreState } from './store.settingsReport';
import { IEventStoreState } from './store.event';
import { IAppSettingsStoreState } from './store.appSettings';
import { IAuthStoreState } from './store.auth';
import { IQuickGuideStoreState } from './store.quickGuide';
import { IUserProfileStoreState } from './store.userProfile';

Vue.use(Vuex);


export interface IRootState {
    authStore: IAuthStoreState;
    appSettingsStore: IAppSettingsStoreState;
    dataSetStore: IDataSetStoreState;
    settingsReportStore: ISettingsReportStoreState;
    eventStore: IEventStoreState;
    quickGuideStore: IQuickGuideStoreState;
    userProfileStore: IUserProfileStoreState;
}

export default new Vuex.Store<IRootState>({
    strict: process.env.NODE_ENV !== 'production',
});
